/**
 * Halbtransparentes Lade-Overlay mit zentriertem Spinner. Legt sich über den
 * Eltern-Container (dieser muss `relative` sein). Wird beim Zeitraum-Wechsel in
 * den Zusammenfassungen eingeblendet, damit alte Daten nicht „live" wirken.
 */
export function LoadingOverlay({ show, rounded = true }: { show: boolean; rounded?: boolean }) {
  if (!show) return null
  return (
    <div
      className={`absolute inset-0 z-10 flex items-center justify-center bg-background/60 ${rounded ? 'rounded-lg' : ''}`}
      aria-busy="true"
    >
      <span className="h-6 w-6 animate-spin rounded-full border-2 border-primary border-t-transparent" />
    </div>
  )
}
